import {
  DeleteButton,
  TextInput,
  SelectInput,
  SaveButton,
} from "@/components/admin";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { Identifier } from "ra-core";
import { EditBase, Form, required, useNotify, useTranslate } from "ra-core";
import { useConfigurationContext } from "../root/ConfigurationContext";

export const TaskEdit = ({
  open,
  close,
  taskId,
}: {
  taskId: Identifier;
  open: boolean;
  close: () => void;
}) => {
  const { taskTypes } = useConfigurationContext();
  const notify = useNotify();
  const translate = useTranslate();
  return (
    <Dialog open={open} onOpenChange={close}>
      {taskId && (
        <EditBase
          id={taskId}
          resource="tasks"
          className="mt-0"
          mutationOptions={{
            onSuccess: () => {
              close();
              notify(translate("simplecrm.tasks.task_updated", { _: "Tarefa atualizada" }), {
                type: "info",
                undoable: true,
              });
            },
          }}
          redirect={false}
        >
          <DialogContent className="lg:max-w-xl overflow-y-auto max-h-9/10 top-1/20 translate-y-0">
            <Form className="flex flex-col gap-4">
              <DialogHeader>
                <DialogTitle>{translate("simplecrm.tasks.edit_task", { _: "Editar tarefa" })}</DialogTitle>
              </DialogHeader>
              <TextInput
                autoFocus
                source="text"
                label={translate("simplecrm.tasks.description", { _: "Descrição" })}
                validate={required()}
                multiline
                helperText={false}
              />
              <div className="flex flex-row gap-4">
                <TextInput
                  source="due_date"
                  label={translate("simplecrm.tasks.due_date", { _: "Data de vencimento" })}
                  helperText={false}
                  type="date"
                  validate={required()}
                />
                <SelectInput
                  source="type"
                  label={translate("simplecrm.tasks.type", { _: "Tipo" })}
                  choices={taskTypes.map((type) => ({
                    id: type,
                    name: type,
                  }))}
                  helperText={false}
                  validate={required()}
                />
              </div>
              <DialogFooter className="w-full sm:justify-between gap-4">
                <DeleteButton
                  mutationOptions={{
                    onSuccess: () => {
                      close();
                      notify(translate("simplecrm.tasks.task_deleted", { _: "Tarefa excluída" }), {
                        type: "info",
                        undoable: true,
                      });
                    },
                  }}
                  redirect={false}
                />
                <SaveButton label={translate("ra.action.save", { _: "Salvar" })} />
              </DialogFooter>
            </Form>
          </DialogContent>
        </EditBase>
      )}
    </Dialog>
  );
};
